import { ProductListItem } from '@shared/model/product';
import { StatusTagData } from './types';

export const ownOrderTag = (product: ProductListItem | undefined): StatusTagData => {
    const code = product?.type.code;
    switch (code) {
        case 'course': {
            return { variant: 'grey', text: 'Курс' };
        }
        case 'file': {
            return { variant: 'grey', text: 'Файл' };
        }
        case 'license_key': {
            return { variant: 'grey', text: 'Лицензия' };
        }
        case 'demo': {
            return { variant: 'grey', text: 'Демо' };
        }
        case 'offline_meeting': {
            return { variant: 'grey', text: 'Мероприятие' };
        }
        case 'online_meeting': {
            return { variant: 'grey', text: 'Вебинар' };
        }
        default: {
            return { variant: 'grey', text: 'Продукт' };
        }
    }
};
